interface TiptapViewerProps {
  content: string
}

export function TiptapViewer({ content }: TiptapViewerProps) {
  return (
    <div
      className="tiptap-viewer prose prose-sm max-w-none"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  )
}
